// extracted by mini-css-extract-plugin
export default {"i_f":"i_f__vPKP-","onzoom":"onzoom__j0Zup","i_bf":"i_bf__EKBPC"};